/**
 * Computes a SHA-256 hex digest of a Blob/File using the browser's SubtleCrypto API.
 * Used for duplicate-file detection — same content always yields the same hash,
 * regardless of file name (so camera captures named "capture.png" are compared correctly).
 */
export async function computeFileHash(blob: Blob): Promise<string> {
  const buffer = await blob.arrayBuffer()

  if (crypto?.subtle) {
    const hashBuffer = await crypto.subtle.digest('SHA-256', buffer)
    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('')
  }

  // Fallback when SubtleCrypto is unavailable (non-secure HTTP context): FNV-1a 32-bit
  const bytes = new Uint8Array(buffer)
  let hash = 0x811c9dc5
  for (let i = 0; i < bytes.length; i++) {
    hash ^= bytes[i]
    hash = (Math.imul(hash, 0x01000193) >>> 0)
  }
  return hash.toString(16).padStart(8, '0')
}
